class Timeline {
    constructor(el) {
        this.dom = {}
        this.dom.el = el
        this.dom.prev = this.dom.el.querySelector('.prev')
        this.dom.next = this.dom.el.querySelector('.next')
        this.dom.list = this.dom.el.querySelector('.list')
        this.dom.items = this.dom.list.querySelectorAll(':scope > .slide')
        this.dom.first = this.dom.items[0] || null
        this.dom.last = this.dom.items[this.dom.items.length - 1] || null
        this.current = 0

        this.touchStartX = 0
        this.touchEndX = 0
        this.mouseWheelDistance = 60
        this.mouseDragDuration = 400
        this.mouseDragStartTime = 0
        this.mouseDragEndTime = 0
        this.mouseDragStartX = 0
        this.mouseDragEndX = 0

        if (this.dom.items.length) {
            // controls
            this.dom.prev.addEventListener('click', this.prev.bind(this))
            this.dom.next.addEventListener('click', this.next.bind(this))

            // touch
            this.dom.list.addEventListener('touchstart', (e) => {
                this.touchStartX = e.changedTouches[0].screenX
            })
            this.dom.list.addEventListener('touchend', (e) => {
                this.touchEndX = e.changedTouches[0].screenX
                if (this.touchEndX < this.touchStartX) this.next()
                if (this.touchEndX > this.touchStartX) this.prev()
            })

            // mouse wheel / touchpad
            this.dom.list.addEventListener('wheel', (e) => {
                if (
                    e.deltaY > this.mouseWheelDistance &&
                    this.dom.items[this.current] !== this.dom.last
                ) {
                    e.preventDefault()
                    e.stopImmediatePropagation()
                    this.next()
                }
                if (
                    e.deltaY < this.mouseWheelDistance * -1 &&
                    this.dom.items[this.current] !== this.dom.first
                ) {
                    e.preventDefault()
                    e.stopImmediatePropagation()
                    this.prev()
                }
            })

            // mouse drag
            this.dom.list.addEventListener('mousedown', (e) => {
                this.mouseDragStartTime = Date.now()
                this.mouseDragStartX = e.clientX
            })
            this.dom.list.addEventListener('mouseup', (e) => {
                this.mouseDragEndTime = Date.now()
                this.mouseDragEndX = e.clientX
                const duration = this.mouseDragEndTime - this.mouseDragStartTime
                const distance = this.mouseDragEndX - this.mouseDragStartX
                if (duration < this.mouseDragDuration) {
                    if (distance < 0) this.next()
                    if (distance > 0) this.prev()
                }
            })

            this.setList()
        }
    }

    setList() {
        for (const [index, item] of this.dom.items.entries()) {
            if (index === this.current) {
                item.classList.value = 'slide active'
            } else if (index === this.current - 1) {
                item.classList.value = 'slide minus one'
            } else if (index === this.current - 2) {
                item.classList.value = 'slide minus two'
            } else if (index === this.current - 3) {
                item.classList.value = 'slide minus three'
            } else if (index === this.current + 1) {
                item.classList.value = 'slide plus one'
            } else if (index === this.current + 2) {
                item.classList.value = 'slide plus two'
            } else if (index === this.current + 3) {
                item.classList.value = 'slide plus three'
            } else if (index < this.current) {
                item.classList.value = 'slide minus'
            } else {
                item.classList.value = 'slide plus'
            }
        }
        this.dom.next.classList.toggle(
            'disabled',
            this.current === this.dom.items.length - 1
        )
        this.dom.prev.classList.toggle('disabled', this.current === 0)
    }

    prev() {
        if (this.current > 0) {
            this.current--
            this.setList()
        }
    }

    next() {
        if (this.current < this.dom.items.length - 1) {
            this.current++
            this.setList()
        }
    }

    checkTouchDirection() {
        if (this.touchendX < this.touchstartX) console.log('swiped left!')
        if (this.touchendX > this.touchstartX) console.log('swiped right!')
    }
}

for (const block of document.querySelectorAll('.vp-block-timeline')) {
    new Timeline(block)
}
